export default __webpack_public_path__ + "static/media/product4.8c863a0c.png";